import React from 'react';
import * as T from "./types";

const defaultEditingStatus: T.IEditingStatus = {
};

export const Context = React.createContext<T.IContextProps>({
  editingStatus: defaultEditingStatus,
  handleEditingStatus: (editingStatus: T.IEditingStatus) => undefined,
});

const Provider: React.FC<T.IProviderProps> = (props) => {
  const [editingStatus, setEditingStatus] = React.useState<T.IEditingStatus>(defaultEditingStatus);

  const handleEditingStatus = (newEditingStatus: T.IEditingStatus) => setEditingStatus(newEditingStatus);

  return (
    <Context.Provider value={{
      editingStatus,
      handleEditingStatus: (editingStatus: T.IEditingStatus) => handleEditingStatus(editingStatus),
    }}>
      {props.children}
    </Context.Provider>
  )
}

export default Provider;